import { PropTypes } from 'prop-types';

export const userShape = PropTypes.shape({
  id: PropTypes.number,
  email: PropTypes.string,
  role: PropTypes.string,
  detailsSubmitted: PropTypes.bool,
  chargesEnabled: PropTypes.bool,
  stripeId: PropTypes.string,
});

export const customerShape = PropTypes.shape({
  id: PropTypes.number,
  address: PropTypes.string,
  city: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
});

export const technicianShape = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
});

export const doctorShape = PropTypes.shape({
  id: PropTypes.number,
  address: PropTypes.string,
  avatarUrl: PropTypes.string,
  calendlyUrl: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  createdAt: PropTypes.string,
  email: PropTypes.string,
  finesId: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  personalEmail: PropTypes.string,
  phone: PropTypes.string,
  rpps: PropTypes.string,
  specialty: PropTypes.string,
  stripeUrl: PropTypes.string,
  teleconsultationRoomUrl: PropTypes.string,
  updatedAt: PropTypes.string,
});

export const teleconsultationShape = PropTypes.shape({
  id: PropTypes.number,
  cancelled: PropTypes.bool,
  createdAt: PropTypes.string,
  doctor: doctorShape,
  endTime: PropTypes.string,
  name: PropTypes.string,
  stage: PropTypes.string,
  startTime: PropTypes.string,
});

export const polygraphyShape = PropTypes.shape({
  id: PropTypes.number,
  createdAt: PropTypes.string,
  customer: customerShape,
  deletedAt: PropTypes.string,
  deliveryDate: PropTypes.string,
  doctor: doctorShape,
  nextAction: PropTypes.string,
  notes: PropTypes.string,
  paymentReminderSentAt: PropTypes.string,
  manualPaymentStatus: PropTypes.string,
  pickupDate: PropTypes.string,
  recordingStatus: PropTypes.string,
  status: PropTypes.string,
  technician: technicianShape,
  updatedAt: PropTypes.string,
});

export const polysomnographyShape = PropTypes.shape({
  id: PropTypes.number,
  createdAt: PropTypes.string,
  customer: customerShape,
  deletedAt: PropTypes.string,
  deliveryDate: PropTypes.string,
  doctor: doctorShape,
  nextAction: PropTypes.string,
  notes: PropTypes.string,
  paymentReminderSentAt: PropTypes.string,
  manualPaymentStatus: PropTypes.string,
  pickupDate: PropTypes.string,
  recordingStatus: PropTypes.string,
  status: PropTypes.string,
  technician: technicianShape,
  updatedAt: PropTypes.string,
});

export const optionShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  default: PropTypes.bool,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const treatingOrgShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
});

export const treatmentShape = PropTypes.shape({
  customer: customerShape,
  doctor: doctorShape,
  referralStatus: PropTypes.oneOfType([optionShape, PropTypes.string]),
  referredAt: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  treatingOrg: treatingOrgShape,
  type: PropTypes.oneOfType([optionShape, PropTypes.string]),
});

export const columnShape = PropTypes.shape({
  accessor: PropTypes.string,
  classNames: PropTypes.string,
  isFilterable: PropTypes.bool,
  label: PropTypes.string,
  selected: PropTypes.bool,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
});

export const rowShape = PropTypes.shape({
  id: PropTypes.number,
  createdAt: PropTypes.string,
  customer: customerShape,
  deletedAt: PropTypes.string,
  deliveryDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  doctor: doctorShape,
  isHighlightedOrange: PropTypes.bool,
  isHighlightedRed: PropTypes.bool,
  nextAction: PropTypes.string,
  notes: PropTypes.string,
  paymentReminderSentAt: PropTypes.string,
  manualPaymentStatus: PropTypes.string,
  pickupDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  recordingStatus: PropTypes.string,
  status: PropTypes.string,
  technician: technicianShape,
  updatedAt: PropTypes.string,
});

export const metaShape = PropTypes.shape({
  currentPage: PropTypes.number,
  itemCount: PropTypes.number,
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number,
  totalPages: PropTypes.number,
});

export const tariffShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  rules: PropTypes.string,
  status: PropTypes.string,
  amount: PropTypes.string,
});

export const paymentIntentShape = PropTypes.shape({
  id: PropTypes.number,
  stripeId: PropTypes.string,
  amount: PropTypes.string,
  status: PropTypes.string,
});

export const stripePaymentIntentShape = PropTypes.shape({
  id: PropTypes.string,
  amount: PropTypes.number,
  status: PropTypes.string,
  charges: PropTypes.shape({
    total_count: PropTypes.number,
  }),
});

export const documentShape = PropTypes.shape({
  type: PropTypes.string,
  name: PropTypes.string,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
});

export const referralShape = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  referralActionType: PropTypes.string,
  nextConsultation: PropTypes.string,
});
